import React from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { ListSelect } from "components/shared/selects"

export const ALL_STATUS = "All"
export const ACTIVE_STATUS = "Active"
export const INACTIVE_STATUS = "Inactive"

const FACILITY_ACTIVE_STATUSES = [
  ALL_STATUS,
  ACTIVE_STATUS,
  INACTIVE_STATUS,
]

const optionsFromList = (options) => options.map((opt) => ({ label: opt, value: opt }))

const DepartmentActiveStatusFilter = ({ onChange, value }) => {
  const { nameInSentence: departmentNameInSentence } = useCustomName(DEPARTMENT_KEY)

  return (
    <ListSelect
      onChange={onChange}
      options={FACILITY_ACTIVE_STATUSES}
      optionsFromList={optionsFromList}
      style={{ width: "11rem" }}
      value={value}
      label={`filter ${departmentNameInSentence} by status`}
    />
  )
}

DepartmentActiveStatusFilter.propTypes = {
  onChange: types.func.isRequired,
  value: types.oneOf(FACILITY_ACTIVE_STATUSES).isRequired,
}

export default DepartmentActiveStatusFilter
